import { isNullOrUndefined, raise } from '@vy/utils';
import { once } from 'lodash';
import { createContext, useContext } from 'react';
import type { FieldValues, FieldPath } from 'react-hook-form';
import type { FormErrorField } from './form-error-notification-context-types/form-error-field';

export type FormErrorNotificationContextProps<
  InputForm extends FieldValues,
  Tab extends string | undefined = undefined,
> = {
  showErrorNotification: boolean;
  setShowErrorNotification: (show: boolean) => void;
  errorsFields: FormErrorField<InputForm, Tab>[];
  registerErrorField: (field: FieldPath<InputForm>, tab?: Tab) => void;
  registerErrorCustomField: (field: string, tab?: Tab) => void;
};

export const createFormErrorNotificationContext = once(<
  InputForm extends FieldValues,
  Tab extends string | undefined = undefined,
>() => createContext<FormErrorNotificationContextProps<InputForm, Tab> | undefined>(undefined));

export function useFormErrorNotificationContext<
  InputForm extends FieldValues,
  Tab extends string | undefined = undefined,
>() {
  const context = useContext(createFormErrorNotificationContext<InputForm, Tab>());

  if (isNullOrUndefined(context)) {
    raise('useFormErrorNotificationContext must be used within a FormErrorNotificationContextProvider');
  }

  return context;
}
